// «القيود» + «دفتر الأستاذ» inside the accounts module (HANDOFF §3:
// /accounts/journal · /accounts/ledger/:accountId; boards accounts/journal,
// journal--manual, ledger). Manager+ (HANDOFF §9 «journal (read), ledger»);
// staff never see the rows and a deep link lands on «اليوم» with the reason.
// The manual-entry panel (?panel=manual) additionally needs the
// accounts.manual_entry capability (owner always) — the server enforces it.
// Module flag erp.accounts: off ⇒ absent everywhere.

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';
import { JOURNAL_PATH, LEDGER_PATH } from './lib/links';

const g = gate({ flag: 'erp.accounts', minRole: 'manager' });

export const ledgerRoutes: RouteObject[] = [
  { path: JOURNAL_PATH, lazy: () => import('./screens/Journal').then((m) => ({ Component: m.JournalRoute })), handle: g },
  { path: LEDGER_PATH, lazy: () => import('./screens/LedgerIndex').then((m) => ({ Component: m.LedgerIndexRoute })), handle: g },
  { path: `${LEDGER_PATH}/:accountId`, lazy: () => import('./screens/Ledger').then((m) => ({ Component: m.LedgerRoute })), handle: g },
];

/** HANDOFF §3 order: … المصروفات · القيود · دفتر الأستاذ · مطابقة البنك · إقفال الفترة. */
export const ledgerMenu: MenuItem[] = [
  { key: 'journal', label: 'القيود', to: JOURNAL_PATH, flag: 'erp.accounts', minRole: 'manager' },
  { key: 'ledger', label: 'دفتر الأستاذ', to: LEDGER_PATH, flag: 'erp.accounts', minRole: 'manager' },
];

export { JOURNAL_PATH, LEDGER_PATH, ledgerHref, journalHref, manualEntryHref, MANUAL_PANEL } from './lib/links';
/** The accounts/close--locked dialog — reusable by any entry point that gets a 409 period_closed. */
export { isPeriodClosed } from './components/Dialogs';
